import { useQuery, useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

export function useDroughtStageUpdate() {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();

  const stagesQuery = useQuery(
    "drought-stages",
    async () => {
      const token = await getAccessTokenSilently();
      const { data } = await axios.get(
        `${process.env.REACT_APP_ENDPOINT}/api/drought-declaration/drought-stages`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return data;
    },
    { staleTime: Infinity, cacheTime: Infinity }
  );

  const zonesQuery = useQuery(
    "drought-zones",
    async () => {
      const token = await getAccessTokenSilently();
      const { data } = await axios.get(
        `${process.env.REACT_APP_ENDPOINT}/api/drought-declaration/drought-zones`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return data;
    },
    { staleTime: Infinity, cacheTime: Infinity }
  );

  const declarationMutation = useMutation(
    async ({ zoneId, zoneStageId, note, effectiveFrom }) => {
      const token = await getAccessTokenSilently();
      return axios.post(
        `${process.env.REACT_APP_ENDPOINT}/api/drought-declaration`,
        { zoneId, zoneStageId, note, effectiveFrom }, // optional
        { headers: { Authorization: `Bearer ${token}` } }
      );
    },
    {
      onSuccess: () => {
        // Invalidate all related queries to refresh the data
        queryClient.invalidateQueries("current"); // Current drought alerts
        queryClient.invalidateQueries("declaration-history"); // Declaration history table
        queryClient.invalidateQueries("zone-calendar"); // Zone calendar view
      },
    }
  );

  return { stagesQuery, zonesQuery, declarationMutation };
}
